// extracted by mini-css-extract-plugin
export default {"tanList":"tanList_tanList__ggCo4"};